import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@@/assets/css/styles.css'
import router from "./router"
import plugins from './plugins'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(plugins)
Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
Vue.use(ElementUI)

// 引入打印
import Print from '@@/utils/printTest'
Vue.use(Print)
router.beforeEach((to, from, next) => {
  if (to.meta.title) {

    document.title = to.meta.title
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // 兼容IE
    window.scrollTo(0, 0);
  }

  next();

});
export function createApp(mainComponent) {
  return new Vue({
    router,
    render: h => h(mainComponent)
  }).$mount('#app')
}
